import { useDocumentTitle } from "@mantine/hooks"
import LoadingBarTop from "@/components/feedback/LoadingBarTop"
import React, { Suspense } from "react"

interface PageProps {
  children: React.ReactNode
  title: string
}

function Page(props: PageProps) {
  useDocumentTitle(`${props.title}${props.title ? " - " : ""}Hado`)

  return (
    <>
      <Suspense fallback={<LoadingBarTop loading />}>{props.children}</Suspense>
    </>
  )
}

export default Page
